import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

interface CustomTooltipProps extends TooltipProps {
  title: React.ReactNode;
  children: React.ReactElement;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  title,
  children,
  ...rest
}) => {
  return (
    <Tooltip
      title={title}
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: '#000000',
            color: '#FFFFFF'
          }
        },
        ...rest.slotProps
      }}
      {...rest} 
    >
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        minWidth: 0,
        flexShrink: 1,
        maxWidth: '100%'
      }}>
        {children}
      </span>
    </Tooltip>
  );
};

export default CustomTooltip;
